import { render, staticRenderFns } from "./configureReviewersType.vue?vue&type=template&id=83aad5e8&"
import script from "./configureReviewersType.vue?vue&type=script&lang=ts&"
export * from "./configureReviewersType.vue?vue&type=script&lang=ts&"
import style0 from "./configureReviewersType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports